import { createAction, props } from "@ngrx/store";

export const getContactType = createAction(
  '[CONTACT] GET CONTACT TYPE',
  props<{ contactType : string }>()
);
